import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  private baseUrl = `${environment.smartPortalApiUrl}Department`;

  constructor(private httpClient: HttpClient) { }

  getDepartments(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}`);
  }

  getDepartmentById(departmentId: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/${departmentId}`);
  }

  addDepartment(department: any): Observable<any> {
    console.log(department);
    return this.httpClient.post(`${this.baseUrl}`, department);
  }

  updateDepartment(departmentId: string, department: any): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/${departmentId}`, department);
  }

  deleteDepartment(departmentId: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/${departmentId}`);
  }

  generateJson(includeSchedule: boolean): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/generate-json/${includeSchedule}`, null, { responseType: 'blob' });
  }

   importDepartments(jsonContent: string): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/import`, { jsonContent }, { responseType: 'text' });
  }

  copyTimeSlots(sourceDepartmentId: string, targetDepartmentIds: string[]): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/copy-time-slots`, {
      sourceDepartmentId,
      targetDepartmentIds
    });
  }
  
}
